var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
const SvgGraduationHat = props => /*#__PURE__*/React.createElement("svg", _extends({
  width: 110,
  height: 105,
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
}, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
  d: "M90.672 77.333v-16.03c0-.957 0-1.435-.146-1.858a2.666 2.666 0 0 0-.616-.996c-.312-.32-.74-.533-1.597-.962L64.005 45.333M21.34 50.667v36.302c0 1.983 0 2.975.309 3.843.274.768.72 1.463 1.303 2.031.66.643 1.562 1.057 3.365 1.883L60.45 110.37c1.308.6 1.962.9 2.643 1.018.604.105 1.22.105 1.825 0 .68-.118 1.335-.418 2.643-1.018l34.133-15.644c1.803-.826 2.705-1.24 3.365-1.883a5.325 5.325 0 0 0 1.303-2.03c.31-.87.31-1.86.31-3.844V50.667m-96-5.334 51.425-25.712c.7-.35 1.05-.525 1.416-.594.326-.06.659-.06.984 0 .367.069.717.244 1.416.594l51.426 25.712-51.426 25.713c-.7.35-1.05.525-1.416.593a2.665 2.665 0 0 1-.983 0c-.367-.068-.717-.243-1.417-.593L10.672 45.333Z",
  stroke: "#fff",
  strokeOpacity: 0.1,
  strokeWidth: 10.68,
  strokeLinecap: "round",
  strokeLinejoin: "round"
})));
export default SvgGraduationHat;